import React, { useState } from 'react';
import { PlayIcon } from '../ui/Icons';

// Video Testimonials Data
const videoTestimonials = [
  {
    id: 1,
    name: 'Tanmi Dutta',
    title: ' CUET UG 2025, Selected for DU',
    thumbnail: '/testimonials/video1-thumb.jpg',
    videoUrl: '/testimonials/tanmi-dutta.mp4', // Replace with actual video
    fallbackImage: '/testimonials/tanmi-dutta.png'
  },
  {
    id: 2,
    name: 'Rinki Soni',
    title: 'CUET PG 2024, 54th Rank Holder',
    thumbnail: '/testimonials/video2-thumb.jpg',
    videoUrl: '/testimonials/rinki-soni.mp4', // Replace with actual video
    fallbackImage: '/testimonials/rinki-soni.png'
  },
  {
    id: 3,
    name: 'Mrigakhi Mahanta',
    title: 'CUET UG 2022, Selected for Tezpur University',
    thumbnail: '/testimonials/video3-thumb.jpg',
    videoUrl: '/testimonials/mrigakhi-mahanta.mp4', // Replace with actual video
    fallbackImage: '/testimonials/mrigakhi-mahanta.png'
  }
];

// Text Testimonials Data
const textTestimonials =[
  {
    id: 1,
    name: 'Tonmoy Kashyap',
    title: 'CUET 2024 Topper',
    image: '/testimonials/aarav.jpg',
    fallbackImage: '/icons/man-user-circle-icon.webp',
    text: " During my CUET exam preparations, I took live classes on General Test papers provided by www.besst.in.I also practised their mock tests."
  },
  {
    id: 2,
    name: 'Rukh Acharya',
    title: 'JEE Advanced Qualifier',
    image: '/testimonials/sneha.jpg',
    fallbackImage: '/icons/man-user-circle-icon.webp',
    text: "  I'm glad that I got to learn about CUET and its fundamentals from BESST. It helped me get into a college in Noida. I'm thankful to you all"
  },
  {
    id: 3,
    name: 'Parashmoni Boruah',
    title: 'NEET 2024 - AIR 850',
    image: '/testimonials/vikram.jpg',
    fallbackImage: '/icons/man-user-circle-icon.webp',
    text: " I have taken online classes with Kaushik Sir; he was the perfect trainer for me I could have imagined. He has been very patient with me and always very supportive. He starts from basics and gradually gets into advanced topics. The study material that sir provided was very useful; students with any level of knowledge can start, learn, and excel. Its practice papers and mock test papers helped me a lot, and the materials of Cuet and UG are very informative. Thank you sir for your support 😎"
  },
  {
    id: 4,
    name: 'Chumi',
    title: 'Delhi University Admission',
    image: '/testimonials/ananya.jpg',
    fallbackImage: '/icons/man-user-circle-icon.webp',
    text: "This web portal is very much useful for any kind of competitive exam preparation.. Specially for cuet.. And also provides live classes...mock tests are also available.. There are lots of questions for every subject for regular practice.. Thank you BESST for providing best materials."
  },
  {
    id: 5,
    name: 'Krishna Maheshwari',
    title: 'Delhi University Admission, 2026',
    image: '/testimonials/ananya.jpg',
    fallbackImage: '/icons/man-user-circle-icon.webp',
    text: "The material provided is quite helpful.A great initiative.Wishing more success and growth to BESST!"
  },
  {
    id: 6,
    name: 'Subodeep Paul',
    title: 'Cleared NET and JRF, 2026',
    image: '/testimonials/subodeep.jpg',
    fallbackImage: '/testimonials/subodeep-paul.jpg',
    text: "The offline classes at BESST were exceptional. The faculty's guidance, in-depth teaching, and structured study materials were instrumental in helping me clear both NET and JRF."
  },
  {
    id: 7,
    name: 'Kaniska',
    title: 'Cleared UGC NET 2026',
    image: '/testimonials/kaniska.jpg',
    fallbackImage: '/testimonials/kaniska.jpg',
    text: "I took the online classes for my preparation. The flexibility of the sessions and the quality of the teaching made a huge difference, ultimately helping me clear UGC NET 2026 successfully."
  },
  {
    id: 8,
    name: 'Lakhwinder Singh',
    title: 'CUET UG 2024 - Selected for DU',
    image: '/testimonials/lakhwinder.jpg',
    fallbackImage: '/testimonials/lakhwinder-singh.jpg',
    text: "BESST's preparation materials and expert guidance were crucial for my CUET UG 2024 exam. Thanks to their immense support and resources, I got selected for Delhi University."
  },
  {
    id: 9,
    name: 'B Lalmuanpuia',
    title: 'Parent (CUET UG 2025 Free Counselling)',
    image: '/testimonials/lalmuanpuia.jpg',
    fallbackImage: '/icons/man-user-circle-icon.webp',
    text: "Ma'am, your team member Mayur Mahanta was extremely helpful and took care of everything for us. My daughter and I are so incredibly happy now, and a huge burden has been lifted off our shoulders. I don't know how to fully express my gratitude—words are simply not enough. Thank you so much once again for all your support. May God bless you abundantly with good health and success."
  }
];

// Video Card Component
const VideoCard = ({ video, onPlay }) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div className="glass-card p-0 overflow-hidden group cursor-pointer" onClick={() => onPlay(video)}>
      <div className="relative aspect-video">
        <img 
          src={imageError ? video.fallbackImage : video.thumbnail}
          alt={video.name}
          className="w-full h-full object-cover"
          onError={() => setImageError(true)}
        />
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center group-hover:bg-black/60 transition-all">
          <div className="w-16 h-16 bg-accent-gold rounded-full flex items-center justify-center transform group-hover:scale-110 transition-transform">
            <PlayIcon className="w-8 h-8 text-gray-900 ml-1" />
          </div>
        </div>
      </div>
      <div className="p-4">
        <h4 className="text-white font-semibold">{video.name}</h4>
        <p className="text-accent-gold text-sm">{video.title}</p>
      </div>
    </div>
  );
};

// Text Testimonial Card Component
const TextTestimonialCard = ({ testimonial }) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div className="glass-card relative">
      <div className="absolute -top-2 -left-2 text-6xl text-accent-gold opacity-30">"</div>
      
      <p className="text-text-light leading-relaxed mb-6 relative z-10 italic">
        {testimonial.text}
      </p>
      
      <div className="flex items-center gap-4">
        <img 
          src={imageError ? testimonial.fallbackImage : testimonial.image}
          alt={testimonial.name}
          className="w-14 h-14 rounded-full object-cover border-2 border-accent-gold"
          onError={() => setImageError(true)}
        />
        <div>
          <h4 className="text-white font-semibold">{testimonial.name}</h4>
          <p className="text-accent-gold text-sm">{testimonial.title}</p>
        </div>
      </div>
    </div>
  );
};

// Video Modal Component
const VideoModal = ({ video, onClose }) => {
  if (!video) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div 
        className="relative w-full max-w-4xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button 
          className="absolute -top-12 right-0 text-white text-3xl hover:text-accent-gold transition-colors"
          onClick={onClose}
        >
          ✕
        </button>
        <div className="aspect-video">
          <iframe
            src={video.videoUrl}
            title={video.name}
            className="w-full h-full rounded-xl"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        <div className="mt-4 text-center">
          <h4 className="text-white font-semibold text-xl">{video.name}</h4>
          <p className="text-accent-gold">{video.title}</p>
        </div>
      </div>
    </div>
  );
};

const TestimonialsSection = () => {
  const [activeVideo, setActiveVideo] = useState(null);

  return (
    <section className="py-20 relative" id="testimonials">
      <div className="max-w-[1400px] mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="section-title">Success Stories</h2>
          <p className="section-subtitle">
            Hear from our students who achieved their dreams with BESST
          </p>
        </div>

        {/* Video Testimonials */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3">
            <span className="w-10 h-10 bg-gradient-to-br from-primary-purple to-light-purple rounded-lg flex items-center justify-center">
              🎥
            </span>
            Video Testimonials
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {videoTestimonials.map((video) => (
              <VideoCard 
                key={video.id} 
                video={video} 
                onPlay={setActiveVideo}
              />
            ))}
          </div>
        </div>

        {/* Text Testimonials */}
        <div>
          <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3">
            <span className="w-10 h-10 bg-gradient-to-br from-primary-purple to-light-purple rounded-lg flex items-center justify-center">
              💬
            </span>
            What Our Students Say
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {textTestimonials.map((testimonial) => (
              <TextTestimonialCard 
                key={testimonial.id} 
                testimonial={testimonial}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Video Modal */}
      <VideoModal video={activeVideo} onClose={() => setActiveVideo(null)} />
    </section>
  );
};

export default TestimonialsSection;